import type { AssetTimelineConditionRatingProps } from "./asset-timeline-condition-rating.type";

import { faker } from "@faker-js/faker";
import { mdiChevronDoubleRight } from "@mdi/js";
import { Icon } from "@mdi/react";
import { Flex } from "antd";
import { useMemo } from "react";

import ConditionRating from "@/components/Asset/ConditionRating";

const SUB_TYPE_KEY = "condition-rating";
const MOCK_DATA = ["A", "B", "C", "D", "E"];

export const AssetTimelineConditionRating = ({
  assetEvent,
  renderWrapper,
}: AssetTimelineConditionRatingProps) => {
  // TODO DEV-4423 - Remove mock data when back-end ready
  const mockEvent = useMemo(() => {
    const value = faker.helpers.arrayElement(MOCK_DATA);
    const previousValue = faker.helpers.arrayElement(
      MOCK_DATA.filter((v) => v !== value)
    );
    return {
      ...assetEvent,
      value,
      previous_event: {
        sub_type: SUB_TYPE_KEY,
        value: previousValue,
      },
    };
  }, [assetEvent.id]);

  const { sub_type, value, previous_event } = mockEvent;

  if (sub_type !== SUB_TYPE_KEY || !value) return null;

  const hasPreviousEvent =
    previous_event?.sub_type === SUB_TYPE_KEY && previous_event?.value
      ? true
      : false;

  if (!hasPreviousEvent) {
    return renderWrapper(<ConditionRating condition={value} />);
  }

  return renderWrapper(
    <Flex gap="small" className="current-previous-value">
      <ConditionRating condition={value} />
      <Icon path={mdiChevronDoubleRight} size="25px" color="gray" />
      <ConditionRating condition={previous_event.value} />
    </Flex>
  );
};
